import $8uBo3$intltablearAEmjs from "../intl/table/ar-AE.mjs";
import $8uBo3$intltablebgBGmjs from "../intl/table/bg-BG.mjs";
import $8uBo3$intltablecsCZmjs from "../intl/table/cs-CZ.mjs";
import $8uBo3$intltabledaDKmjs from "../intl/table/da-DK.mjs";
import $8uBo3$intltabledeDEmjs from "../intl/table/de-DE.mjs";
import $8uBo3$intltableelGRmjs from "../intl/table/el-GR.mjs";
import $8uBo3$intltableenUSmjs from "../intl/table/en-US.mjs";
import $8uBo3$intltableesESmjs from "../intl/table/es-ES.mjs";
import $8uBo3$intltableetEEmjs from "../intl/table/et-EE.mjs";
import $8uBo3$intltablefiFImjs from "../intl/table/fi-FI.mjs";
import $8uBo3$intltablefrFRmjs from "../intl/table/fr-FR.mjs";
import $8uBo3$intltableheILmjs from "../intl/table/he-IL.mjs";
import $8uBo3$intltablehrHRmjs from "../intl/table/hr-HR.mjs";
import $8uBo3$intltablehuHUmjs from "../intl/table/hu-HU.mjs";
import $8uBo3$intltableitITmjs from "../intl/table/it-IT.mjs";
import $8uBo3$intltablejaJPmjs from "../intl/table/ja-JP.mjs";
import $8uBo3$intltablekoKRmjs from "../intl/table/ko-KR.mjs";
import $8uBo3$intltableltLTmjs from "../intl/table/lt-LT.mjs";
import $8uBo3$intltablelvLVmjs from "../intl/table/lv-LV.mjs";
import $8uBo3$intltablenbNOmjs from "../intl/table/nb-NO.mjs";
import $8uBo3$intltablenlNLmjs from "../intl/table/nl-NL.mjs";
import $8uBo3$intltableplPLmjs from "../intl/table/pl-PL.mjs";
import $8uBo3$intltableptBRmjs from "../intl/table/pt-BR.mjs";
import $8uBo3$intltableptPTmjs from "../intl/table/pt-PT.mjs";
import $8uBo3$intltableroROmjs from "../intl/table/ro-RO.mjs";
import $8uBo3$intltableruRUmjs from "../intl/table/ru-RU.mjs";
import $8uBo3$intltableskSKmjs from "../intl/table/sk-SK.mjs";
import $8uBo3$intltableslSImjs from "../intl/table/sl-SI.mjs";
import $8uBo3$intltablesrSPmjs from "../intl/table/sr-SP.mjs";
import $8uBo3$intltablesvSEmjs from "../intl/table/sv-SE.mjs";
import $8uBo3$intltabletrTRmjs from "../intl/table/tr-TR.mjs";
import $8uBo3$intltableukUAmjs from "../intl/table/uk-UA.mjs";
import $8uBo3$intltablezhCNmjs from "../intl/table/zh-CN.mjs";
import $8uBo3$intltablezhTWmjs from "../intl/table/zh-TW.mjs";

var $67ffa2e41349580b$exports = {};


































$67ffa2e41349580b$exports = {
    "ar-AE": $8uBo3$intltablearAEmjs,
    "bg-BG": $8uBo3$intltablebgBGmjs,
    "cs-CZ": $8uBo3$intltablecsCZmjs,
    "da-DK": $8uBo3$intltabledaDKmjs,
    "de-DE": $8uBo3$intltabledeDEmjs,
    "el-GR": $8uBo3$intltableelGRmjs,
    "en-US": $8uBo3$intltableenUSmjs,
    "es-ES": $8uBo3$intltableesESmjs,
    "et-EE": $8uBo3$intltableetEEmjs,
    "fi-FI": $8uBo3$intltablefiFImjs,
    "fr-FR": $8uBo3$intltablefrFRmjs,
    "he-IL": $8uBo3$intltableheILmjs,
    "hr-HR": $8uBo3$intltablehrHRmjs,
    "hu-HU": $8uBo3$intltablehuHUmjs,
    "it-IT": $8uBo3$intltableitITmjs,
    "ja-JP": $8uBo3$intltablejaJPmjs,
    "ko-KR": $8uBo3$intltablekoKRmjs,
    "lt-LT": $8uBo3$intltableltLTmjs,
    "lv-LV": $8uBo3$intltablelvLVmjs,
    "nb-NO": $8uBo3$intltablenbNOmjs,
    "nl-NL": $8uBo3$intltablenlNLmjs,
    "pl-PL": $8uBo3$intltableplPLmjs,
    "pt-BR": $8uBo3$intltableptBRmjs,
    "pt-PT": $8uBo3$intltableptPTmjs,
    "ro-RO": $8uBo3$intltableroROmjs,
    "ru-RU": $8uBo3$intltableruRUmjs,
    "sk-SK": $8uBo3$intltableskSKmjs,
    "sl-SI": $8uBo3$intltableslSImjs,
    "sr-SP": $8uBo3$intltablesrSPmjs,
    "sv-SE": $8uBo3$intltablesvSEmjs,
    "tr-TR": $8uBo3$intltabletrTRmjs,
    "uk-UA": $8uBo3$intltableukUAmjs,
    "zh-CN": $8uBo3$intltablezhCNmjs,
    "zh-TW": $8uBo3$intltablezhTWmjs
};


export {$67ffa2e41349580b$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
